<div class="no-appid-container" role="region" aria-label="Login error message">
  <header class="follett-banner" role="banner">
    <div class="banner-content">
      <span class="follett-logo" aria-label="Follett">Follett</span>
    </div>
  </header>
  <div class="content-wrapper" role="main">
    @if (missingAppIdError){
      <div class="message-box" role="alert" aria-live="polite">
        <h1 class="heading" id="error-heading">To log you in, we need your school information</h1>
        <p class="message">
          @if (goFollettLink) {
            <a [href]="goFollettLink"
               aria-label="Find your school now on Follett's website">Find your school now</a>
          } @else {
            <span>Find your school now</span>
          }
        </p>
        <p class="help-text">If you're still unable to log in, please contact your system administrator</p>
      </div>
    } @else {
      <div class="message-box" role="alert" aria-live="polite">
        <h1 class="heading" id="error-heading">Error</h1>
        <p class="help-text">An error occurred. Please try again. If you're still unable to log in, please contact your system administrator</p>
      </div>
    }
  </div>
</div>
